import  useNavigation from '../../../hooks/useNavigation.js'

export const commissionColoumns = () => {
  const { navigateTo } = useNavigation();
  const viewAgent = (row) => {
    let id=row.sender_id
    if(row.transaction_type == "PAYIN") {
      id = row.receiver_id
    }
    navigateTo('viewAgent','view-agent',id)
  }
  const columns = 
  [
    {
      name: 'Order ID',
      cell: row => <div className="custom-cell-order_Code"><a href="javascript:void(0)" onClick={() =>  navigateTo('viewCommission','commssion-view',row.id)}>{row.order_code}</a></div>,
      sortable: true,
    },
    {
      name: 'Agent',
      cell: row => <div className="custom-cell-order_Code">{row.agent_name || '-'}</div>,
      sortable: true,
     
    },
    {
      name: 'Payment Type',
      selector: row => <>
      <div style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }}><i className="fa fa-money me-1" style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }} />
      {row.transaction_type.toLowerCase().charAt(0).toUpperCase() + row.transaction_type.toLowerCase().slice(1)}
      </div>
      </>,
      sortable: true,
    },
       {
          name: 'Agent Code',
          cell: row => (
            <div className="custom-cell-order_Code">
              {row.agent_code && row.agent_code.trim() !== '-' ? (
                <a href="javascript:void(0)" onClick={() => viewAgent(row)}>{row.agent_code}</a>
              ) : (
                '-'
              )}
            </div>
          ),
          sortable: true,
         
        },
    {
      name: 'Date',
      selector: row => row.start_date,
      sortable: true,
    },     
    {
      name: 'Total',
      selector: row => '₹' + row.transaction_amount,
      sortable: true,
    },
    
    {
      name: 'Payment Method',
      selector: row => 
      <>
      <i className={`fa  me-1 ${
        row.payment_method && row.payment_method.toLowerCase() === 'imps' ? 'fa-money' :
                            row.payment_method && row.payment_method.toLowerCase() === 'wallet' ? 'fa-credit-card' :
                            row.payment_method && row.payment_method.toLowerCase() === 'upi' ? 'fa-google-wallet' :
                            row.payment_method && row.payment_method.toLowerCase() === 'qr' ? 'fa-qrcode ' :
                            ''}`} /> {row.payment_method || '-'}
      
      </>
      
      ,
      sortable: true,
    },
    {
      name: 'Actions',
      selector: row => <>

      <div  style={{display:'flex'}}>
      
        <a className="fview tooltip" style={{'cursor':'pointer'}} onClick={() => {
          navigateTo('viewCommission','commssion-view',row.id);
        }}>
          <i className="fa fa-eye" />
          <span className="tooltiptext"  >View</span>
        </a>
        </div>
      </>
    },
  ]


  return columns
}

